import React from "react";

const LOGOS_DIR = "/vendor-partner-logos";

function fromFolder(filename) {
  return `${LOGOS_DIR}/${filename}`;
}

const vendors = [
  { name: "ABB", src: fromFolder("abb-logo.png"), width: 400, height: 200 },
  { name: "BluePath Robotics", src: "/bluepath.png", width: 409, height: 123 },
  { name: "Hovair Automotive", src: fromFolder("hovair-logo.png"), width: 400, height: 200 },
  { name: "KUKA", src: fromFolder("kuka-logo.png"), width: 400, height: 200 },
  { name: "Nichols Material Handling", src: fromFolder("nmh-logo.png"), width: 400, height: 200 },
  { name: "OTTO by Rockwell Automation", src: fromFolder("otto-rockwell-logo.png"), width: 400, height: 200 },
  { name: "SailRail", src: fromFolder("sailrail-logo.png"), width: 400, height: 200, larger: true },
  { name: "SEER Robotics", src: fromFolder("seer-robotics-logo.png"), width: 400, height: 200 },
  { name: "Slamcore", src: fromFolder("slamcore-logo.png"), width: 400, height: 200 },
  { name: "SYNAOS", src: fromFolder("synaos-logo.png"), width: 400, height: 200 },
  { name: "VisionNav", src: fromFolder("visionnav-logo.png"), width: 400, height: 200 },
];

const itemClassName = "flex shrink-0 items-center justify-center px-12 sm:px-14";

function logoClass(larger) {
  return larger
    ? "h-[4.6875rem] w-auto max-w-[315px] object-contain sm:h-[5.625rem]"
    : "h-[3.75rem] w-auto max-w-[252px] object-contain sm:h-[4.5rem]";
}

function LogoItem({ name, src, width, height, larger }) {
  return (
    <span className={itemClassName}>
      <img
        src={src}
        alt={name}
        width={width}
        height={height}
        className={logoClass(larger)}
        loading="eager"
        decoding="async"
        draggable="false"
      />
    </span>
  );
}

function LogoClone({ src, width, height, larger }) {
  return (
    <span className={itemClassName}>
      <span
        className={`${logoClass(larger)} block bg-contain bg-center bg-no-repeat`}
        style={{ backgroundImage: `url(${src})`, aspectRatio: `${width} / ${height}` }}
      />
    </span>
  );
}

export default function HomePartnerMarquee() {
  return (
    <section className="border-y border-gray-200 bg-white" aria-labelledby="home-vendors-heading">
      <div className="mx-auto max-w-3xl px-4 pt-14 text-center sm:px-6 sm:pt-16">
        <h2
          id="home-vendors-heading"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          A partner network that provides the most value for your operations.
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-gray-600 sm:text-base">
          A vendor-agnostic approach allows MAG to select the best technologies for your project.
        </p>
      </div>

      <div className="mag-logo-marquee relative mt-10 overflow-hidden pb-14 sm:mt-12 sm:pb-16">
        <div className="mag-logo-marquee-track hidden w-max motion-safe:flex motion-reduce:flex motion-reduce:w-auto motion-reduce:flex-wrap motion-reduce:items-center motion-reduce:justify-center motion-reduce:gap-x-6 motion-reduce:gap-y-6 motion-reduce:px-4 motion-reduce:pb-1 sm:motion-reduce:px-6">
          {vendors.map((vendor) => (
            <LogoItem key={vendor.name} {...vendor} />
          ))}
          <div className="flex items-center motion-reduce:hidden" aria-hidden="true">
            {vendors.map((vendor) => (
              <LogoClone key={`clone-${vendor.name}`} {...vendor} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
